// TODO: remove this component and use the ReviewCard component instead
// This component is only used in the booking complete service professional section

import { Image, View } from "@/components/ui";
import { Card, CardContent } from "@/components/ui/card";
import { Ratings } from "@/components/ui/ratings";
import { cn } from "@/lib/utils";
import type { Review } from "@/types/booking";
import { IfElse } from "../if-else";
import { Spin } from "@/components/shared/spin";
import { Typography } from "../typography";

export function ReviewCard({
  loading,
  id,
  clientName,
  rating,
  createdAt,
  ltv,
  service,
  description,
  images,
  showImages = true,
  cardBorderStyle = "default",
  numberOfLines = 3,
  contentClassName,
  onClick,
}: Review & {
  loading?: boolean;
  showImages?: boolean;
  cardBorderStyle?: "default" | "hiddenInLargeScreen" | "none";
  numberOfLines?: number;
  contentClassName?: string;
  onClick?(item: Review): void;
}) {
  return (
    <Card
      shadow="none"
      radius="xl"
      border={cardBorderStyle}
      className="w-full justify-start"
      onClick={() =>
        onClick?.({
          id,
          clientName,
          rating,
          createdAt,
          ltv,
          service,
          description,
          images,
        })
      }
    >
      <CardContent
        className={cn(
          "m-2 flex flex-col gap-2 md:m-0 md:p-1",
          contentClassName,
        )}
      >
        <IfElse
          if={!loading}
          else={
            <View>
              <Spin className="my-10 size-8" />
            </View>
          }
        >
          <View className="flex h-full flex-col">
            <View className="inline-flex flex-row items-center gap-2">
              <Ratings variant="yellow" rating={rating} />
              <Typography variant="body-sm" color="foreground-intermediate">
                {new Intl.DateTimeFormat("en-US", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                }).format(createdAt)}
              </Typography>
            </View>

            <View className="flex flex-1 flex-col gap-2">
              <Typography variant="caption-md">{service}</Typography>
              <Typography variant="body-sm" numberOfLines={numberOfLines}>
                {description}
              </Typography>

              {showImages && !!images?.length && (
                <View className="ReviewCard-images flex flex-row flex-wrap gap-1">
                  {images.map((image, iImg) => (
                    <View
                      className="w-[32%] overflow-hidden rounded-md"
                      key={iImg}
                    >
                      <Image
                        src={image}
                        className="aspect-square overflow-hidden rounded-md object-cover"
                        contentFit="cover"
                        style={{
                          height: undefined,
                          width: "100%",
                          aspectRatio: 1,
                        }}
                      />
                    </View>
                  ))}
                </View>
              )}

              <View className="mt-auto flex flex-col">
                <Typography variant="label-sm">{clientName}</Typography>
                <Typography
                  variant="caption-md"
                  color="foreground-intermediate"
                >
                  {ltv} lifetime bookings
                </Typography>
              </View>
            </View>
          </View>
        </IfElse>
      </CardContent>
    </Card>
  );
}
